import { gql } from 'apollo-boost'

/**
 * The `processEvent` (integration event) mutation.
 *
 * Shared rather than re-declared per dialog: `react-quote` can't import
 * `apps/shared`'s `useProcessEvent` hook, and `EditItemFilesDialogNext` is a class
 * component that goes through an injected Apollo client anyway — so both it and
 * `AddFileDialog` had their own copy of this document, free to drift apart if
 * `processEvent` ever gains a field.
 */
export const PROCESS_EVENT = gql`
  mutation ($type: String!, $provider: String!, $async: Boolean, $params: JSON) {
    processEvent(type: $type, provider: $provider, async: $async, params: $params) {
      provider
      result
      error
    }
  }
`
